import * as Semantic from 'semantic-ui-react';
import * as React from 'react';
import * as Styles from './phoneticsmodal.styles';
import { LanguageCode } from '@visikon/core-models/languageTypes';
import PhoneticsList from './PhoneticsList';
import { PhoneticEditor } from './PhoneticEditor';
import { LexemeCreationEntry } from '@visikon/core-models';
import { useMediaQuery } from 'commons/utils';

// Semantic's "large" modal is capped at ~1080px, which is too cramped for the editor and list side by side on smaller windows
const FULLSCREEN_MODAL_QUERY = '(max-width: 1439.98px)';

export default function PhoneticsTestModal({
  activeLanguage,
  selectedVoiceId,
  children,
  manuscript,
}: {
  activeLanguage: LanguageCode;
  selectedVoiceId: string;
  children: JSX.Element;
  manuscript: string;
}) {
  const [lang, setLang] = React.useState<LanguageCode>(activeLanguage);
  const [activeLexeme, setActiveLexeme] = React.useState<LexemeCreationEntry>();
  const setLanguageCallback = React.useCallback(setLang, [setLang]);
  const isSmallWindow = useMediaQuery(FULLSCREEN_MODAL_QUERY);

  const handleSelectLexeme = (lexeme: LexemeCreationEntry | null) => {
    setActiveLexeme(lexeme ?? undefined);
  };

  return (
    <Semantic.Modal
      trigger={children}
      size={isSmallWindow ? 'fullscreen' : 'large'}
      dimmer="blurring"
      inverted="false"
      onClick={(e: Event) => {
        e.stopPropagation();
      }}
      // Hack to prevent Dropdown in SpeakVariation from toggling it's open state when pressing space while the modal is open
      // This caused spaces not to be registered in the phoneme editor
      onKeyDown={(e: React.KeyboardEvent) => {
        if (e.key !== ' ') return;

        e.stopPropagation();
      }}
      onKeyUp={(e: React.KeyboardEvent) => {
        if (e.key !== ' ') return;

        e.stopPropagation();
      }}
    >
      <Semantic.Modal.Content style={{ display: 'flex', gap: '1rem' }}>
        <PhoneticEditor
          lexeme={activeLexeme}
          selectedVoiceId={selectedVoiceId}
          language={lang}
          onSelectLexeme={handleSelectLexeme}
          onLanguageChanged={setLanguageCallback}
          manuscript={manuscript}
        />
        <Semantic.Container style={{ position: 'relative' }}>
          <Styles.TestModalTitle>Phonetics List</Styles.TestModalTitle>
          <PhoneticsList activeLexeme={activeLexeme} onSelectLexeme={handleSelectLexeme} lang={lang} />
        </Semantic.Container>
      </Semantic.Modal.Content>
    </Semantic.Modal>
  );
}
